<agr-page-toolbar
  [isEmpty]="(barns$ | async)?.length === 0"
  [emptyTitle]="'settings.barn.no-barns-title' | translate"
  [emptyDescription]="'settings.barn.no-barns-description' | translate"
  emptyImage="assets/images/pigs_001.jpg"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="addDialog()"
  data-test="barn-overview"
>
  <ng-container *ngIf="(isLoading$ | async) === false && barns$ | async as barns">
    <mat-nav-list role="list" *ngIf="barns.length" class="barn-overview__list">
      <a
        mat-list-item
        role="listitem"
        class="barn-item"
        data-test="barn-overview__item"
        *ngFor="let barn of barns"
        (click)="openBarnEdit(barn.id)"
      >
        <mat-icon matListItemAvatar class="list-avatar" svgIcon="mdi-barn"></mat-icon>
        <div matListItemTitle>{{ barn.name }}</div>
        <div matListItemLine class="text--gray">{{ barn.surfaceArea | agrNumber }} m2</div>
        <div matListItemMeta>
          <button mat-icon-button (click)="delete($event, barn)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </a>
      <mat-divider *ngIf="barns.length > 0"></mat-divider>
    </mat-nav-list>
  </ng-container>
</agr-page-toolbar>
